/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const ExitIcon: React.SFC = () => {
    return (
        <svg width="18" height="19" viewBox="0 0 18 19">
          <g fill="#FFFFFF" fillRule="evenodd">
            <path d="M3 17v2h15V0H3v2h13v15H3z"/>
            <path d="M4 8h6v3H4v3L0 9.5 4 5v3z"/>
          </g>
        </svg>
    )
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Exit/Exit.tsx